import { useController } from "react-hook-form";

export function Toggle({ name, control, onAfterChange }) {
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const handleClick = () => {
    const next = !value;
    onChange(next);
    onAfterChange?.(next);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors
        duration-200 ${value ? "bg-indigo-600" : "bg-gray-300"}`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition
          duration-200 ${value ? "translate-x-5" : "translate-x-1"}`}
      />
    </button>
  );
}
